import { Localized } from "@fluent/react";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useState } from "react";
import { CancelButton } from "../../../../app/components/CancelButton";
import { YesButton } from "../../../../app/components/YesButton";
import { AppId } from "../../../../app/appTypes";
import { useAppDispatch } from "../../../../app/hooks";
import { sendDocumentTeamMemberReminder } from "../teamMemberApi";
import { showError, showSuccess } from "../../../notifications/notificationsSlice";

export interface TeamMemberSendReminderDialogProps {
    documentId: AppId;
    onCancel: () => void;
    onSuccessfulSend: () => void;
}

export const TeamMemberSendReminderDialog = ({
    documentId,
    onCancel,
    onSuccessfulSend,
}: TeamMemberSendReminderDialogProps) => {
    const dispatch = useAppDispatch();
    const [sending, setSending] = useState(false);
    const [serverError, setServerError] = useState("");

    const handleYesClick = async () => {
        setSending(true);
        setServerError("");
        try {
            const result = await dispatch(sendDocumentTeamMemberReminder({ documentId }));

            if (sendDocumentTeamMemberReminder.fulfilled.match(result)) {
                dispatch(showSuccess("sent"));
                onSuccessfulSend();
            } else {
                let errorMsg = "error"
                if (result.payload && result.payload.kind === 'http') {
                    const problem = result.payload.problem
                    if (problem) {
                        errorMsg = problem.title

                    }
                }
                setServerError(errorMsg)
            }
        } catch (error) {
            dispatch(showError("error"));
        } finally {
            setSending(false);
        }
    };

    return (
        <Dialog open fullWidth maxWidth="xs" onClose={sending ? undefined : onCancel}>
            <DialogTitle>
                <Localized id="document-reminder-title">
                    <span>_Wyślij przypomnienie</span>
                </Localized>
            </DialogTitle>

            <DialogContent>
                <DialogContentText component="div">
                    <Alert severity="info" variant="outlined" sx={{ mt: 2 }}>
                        <Localized id="document-reminder-question">
                            <span>_Czy na pewno wysłać przypomnienie o bieżących akcjach do wykonania?</span>
                        </Localized>
                    </Alert>
                </DialogContentText>
                {
                    serverError && <Alert sx={{ marginTop: 1, }} onClose={() => { setServerError("") }} severity="error">
                        <Localized id={serverError}>
                            <span>_Server error</span>
                        </Localized>
                    </Alert>
                }
            </DialogContent>

            <DialogActions sx={{ px: 3, pb: 2 }}>
                <YesButton loading={sending} onClick={handleYesClick} />
                <CancelButton loading={sending} onClick={onCancel} />
            </DialogActions>
        </Dialog>
    );
};
